import { render } from "./readAestheticEdu.vue?vue&type=template&id=99727e46&scoped=true"
import script from "./readAestheticEdu.vue?vue&type=script&lang=js"
export * from "./readAestheticEdu.vue?vue&type=script&lang=js"

import "./readAestheticEdu.vue?vue&type=style&index=0&id=99727e46&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99727e46"]])

export default __exports__